<template>
  <RouterView />
</template>

<script setup lang="ts">
import { getAllowSignup } from '@/api/cms/auth'
import { getICPConfig } from '@/api/cms/system'
import { useGlobalStore } from '@/stores/global-store'

const globalStore = useGlobalStore()

const fetchSignupPolicy = async () => {
  try {
    const res = await getAllowSignup()
    if (res.code === 0) {
      globalStore.setSignupPolicy(typeof res.data === 'boolean' ? res.data : true)
    }
  } catch (error) {
    console.error('获取注册政策失败', error)
  }
}

const fetchICPConfig = async () => {
  try {
    const res = await getICPConfig()
    if (res.code === 0) {
      globalStore.setICPConfig(res.data || '')
    }
  } catch (error) {
    console.error('获取ICP配置失败', error)
  }
}

fetchSignupPolicy()
fetchICPConfig()
</script>

<style lang="scss">
body {
  margin: 0;
  min-width: 20rem;
}
</style>
